export const oms_language = {
  TH: {
    oms: 'OMS',
    location: 'Stock Location',
    my_product: 'สินค้าของฉัน',
    stock_group: 'สต๊อก',
    warehouse_transfer: 'นำเข้า/นำออก/โอนย้ายสินค้า',
    location_management: 'จัดการ Stock Location',
    add_location: 'เพิ่ม Location',
    edit_location: 'แก้ไข Location',
    import_excel: 'นำเข้าจาก Excel',
    download_template: 'ดาวน์โหลดไฟล์ตัวอย่าง',
    channel: 'ช่องทาง',
    channel_on: 'ON (On-premise)',
    channel_tt: 'TT (Traditional Trade)',
    code: 'รหัส',
    name: 'ชื่อ Location',
    status: 'สถานะ',
    active: 'ใช้งาน',
    inactive: 'ปิดใช้งาน',
    no: 'ลำดับ',
    edit: 'แก้ไข',
    record: 'บันทึก',
    cancel: 'ยกเลิก',
    close: 'ปิด',
    search: 'ค้นหา',
    all: 'ทั้งหมด',
    please_specify: 'กรุณาระบุ',
    no_data: 'ไม่มีข้อมูล',
    success: 'สำเร็จ',
    cannot_perform_operation: 'ไม่สามารถทำรายการได้',
    network_error: 'เชื่อมต่อระบบไม่ได้ กรุณาลองใหม่อีกครั้ง',
    choose_file: 'เลือกไฟล์ Excel',
    import_result: 'ผลการนำเข้า',
    import_success_count: 'นำเข้าสำเร็จ',
    import_error_count: 'ไม่สำเร็จ',
    rows: 'แถว',
    row: 'แถวที่',
    reason: 'สาเหตุ',
    file_empty: 'ไม่พบข้อมูลในไฟล์',
    import_hint_location: 'ไฟล์ต้องมีคอลัมน์ ช่องทาง (ON หรือ TT), รหัส (เว้นว่างได้) และ ชื่อ Location ชื่อที่มีอยู่แล้วจะถูกอัปเดต ไม่สร้างซ้ำ',

    // ผู้ใช้
    user: 'ผู้ใช้',
    user_management: 'จัดการผู้ใช้',
    add_user: 'เพิ่มผู้ใช้',
    edit_user: 'แก้ไขผู้ใช้',
    create_account: 'สร้างบัญชีผู้ใช้ใหม่',
    phone: 'เบอร์โทร',
    password: 'รหัสผ่าน',
    confirm_password: 'ยืนยันรหัสผ่าน',
    password_mismatch: 'รหัสผ่านไม่ตรงกัน',
    change_password: 'เปลี่ยนรหัสผ่าน',
    change_my_password: 'เปลี่ยนรหัสผ่านของฉัน',
    current_password: 'รหัสผ่านปัจจุบัน',
    new_password: 'รหัสผ่านใหม่',
    password_changed_relogin: 'เปลี่ยนรหัสผ่านแล้ว กรุณาเข้าสู่ระบบใหม่',
    staff: 'ผู้ใช้',
    username: 'Username',
    staff_name: 'ชื่อ',
    role: 'สิทธิ์',
    role_ADMIN: 'Admin',
    role_CREATOR: 'Sale',
    role_APPROVER: 'Manager',
    channel_ALL: 'ทุกช่องทาง',
    delete: 'ลบ',
    confirm: 'ยืนยัน',
    confirm_delete_user: 'ลบสิทธิ์ OMS ของผู้ใช้นี้ บัญชีผู้ใช้ของระบบยังอยู่',
    all_location: 'ทุก Location',
    import_hint_user: 'ไฟล์ต้องมีคอลัมน์ Username (บัญชีต้องมีอยู่แล้ว), ช่องทาง (ON หรือ TT), สิทธิ์ (ADMIN, CREATOR หรือ APPROVER) และ Location ถ้ามีหลาย Location ให้คั่นด้วยเครื่องหมาย |',

    // คำสั่งซื้อ
    add_order: 'สร้างคำสั่งซื้อ',
    order_list: 'รายการคำสั่งซื้อ',
    edit_order_request: 'แก้ไขคำสั่งซื้อ',
    order_info: 'ข้อมูลคำสั่งซื้อ',
    request_no: 'เลขที่คำขอ',
    submitted_at: 'วันที่ส่ง',
    created_by: 'ผู้สร้าง',
    date_from: 'ตั้งแต่วันที่',
    date_to: 'ถึงวันที่',
    only_mine: 'เฉพาะของฉัน',
    items_and_pieces: 'รายการ / ชิ้น',
    pieces: 'ชิ้น',
    selected: 'เลือกแล้ว',
    only_selected: 'เฉพาะที่เลือก',
    order_qty: 'จำนวนที่สั่ง',
    remark: 'หมายเหตุ',
    express: 'ขนส่ง',
    sales_channel: 'ช่องทางการขาย',
    please_select_express: 'กรุณาเลือกขนส่ง',
    please_select_sales_channel: 'กรุณาเลือกช่องทางการขาย',
    round: 'รอบที่',
    reject_reason: 'เหตุผลที่ไม่อนุมัติ',
    submit_for_approval: 'ส่งขออนุมัติ',
    resubmit: 'ส่งขออนุมัติอีกครั้ง',
    edit_and_resubmit: 'แก้ไขแล้วส่งใหม่',
    cancel_order_request: 'ยกเลิกคำสั่งซื้อ',
    confirm_cancel_order_request: 'ยืนยันยกเลิกคำสั่งซื้อนี้ โควตาที่จองไว้จะถูกคืน',
    approval_history: 'ประวัติการอนุมัติ',
    submitted_wait_manager: 'ส่งคำสั่งซื้อแล้ว รอผู้จัดการอนุมัติ',
    no_on_location: 'บัญชีนี้ไม่ได้สังกัด Location ของช่องทาง ON จึงสร้างคำสั่งซื้อที่ต้องอนุมัติไม่ได้',
    no_product_in_location: 'Location นี้ยังไม่ได้รับโควตาสินค้า',
    store_has_no_address: 'ร้านค้านี้ยังไม่มีที่อยู่จัดส่ง กรุณาติดต่อ Admin',
    please_select_store: 'กรุณาเลือกร้านค้า',
    please_select_product: 'กรุณาระบุจำนวนสินค้าอย่างน้อย 1 รายการ',
    order_qty_over_available: 'มีสินค้าที่สั่งเกินจำนวนคงเหลือ',
    product_no_longer_available: 'มีสินค้าที่เลือกไว้ซึ่ง Location นี้ไม่มีโควตาแล้ว กรุณาตรวจสอบรายการอีกครั้ง',
    available_now: 'คงเหลือล่าสุด',
    approval: 'อนุมัติคำสั่งซื้อ',
    approval_pending: 'รออนุมัติ',
    my_action: 'การอนุมัติของฉัน',
    approved_by_me: 'ที่ฉันอนุมัติ',
    rejected_by_me: 'ที่ฉันไม่อนุมัติ',
    approve_selected: 'อนุมัติที่เลือก',
    approve_result: 'อนุมัติสำเร็จ',
    confirm_approve_manager: 'อนุมัติแล้วคำสั่งซื้อจะถูกส่งต่อให้ Admin อนุมัติ',
    confirm_approve_admin: 'อนุมัติแล้วระบบจะสร้างออเดอร์จริงและส่งเข้าคลังทันที ยกเลิกจากหน้านี้ไม่ได้',
    reject_order_request: 'ไม่อนุมัติคำสั่งซื้อ',
    reject_hint: 'คำสั่งซื้อจะถูกส่งกลับไปที่ผู้สร้างเพื่อแก้ไข และโควตาที่จองไว้จะถูกคืน',
    approved_order_created: 'อนุมัติแล้ว เลขออเดอร์',
    status_WAIT_MANAGER: 'รอผู้จัดการอนุมัติ',
    status_WAIT_ADMIN: 'รอ Admin อนุมัติ',
    status_REJECTED: 'ไม่อนุมัติ',
    status_CANCELLED: 'ยกเลิก',
    status_APPROVED: 'อนุมัติแล้ว',
    tab_order: 'ออเดอร์',
    action_SUBMIT: 'ส่งขออนุมัติ',
    action_RESUBMIT: 'แก้ไขแล้วส่งใหม่',
    action_APPROVE: 'อนุมัติ',
    action_REJECT: 'ไม่อนุมัติ',
    action_CANCEL: 'ยกเลิก',
    level_CREATOR: 'Sale',
    level_MANAGER: 'Manager',
    level_ADMIN: 'Admin',
    action_ORDER_CANCELLED: 'ออเดอร์ถูกยกเลิกโดยคลัง คืนสต๊อกแล้ว',
    status_ORDER_CANCELLED: 'ออเดอร์ถูกยกเลิกโดยคลัง คืนสต๊อกแล้ว',
    create_order_now: 'สร้างคำสั่งซื้อ',
    order_created_direct: 'สร้างออเดอร์แล้ว และส่งเข้าคลังทันที',

    // สต๊อก / ร้านค้า
    stock: 'สต๊อกสินค้า',
    stock_by_location: 'สต๊อกตาม Location',
    only_available: 'เฉพาะสินค้าที่ยังสั่งได้',
    no_location_assigned: 'บัญชีนี้ยังไม่ได้ผูกกับ Location กรุณาติดต่อ Admin',
    store: 'ร้านค้า',
    add_store: 'เพิ่มร้านค้า',
    edit_store: 'แก้ไขร้านค้า',
    zipcode: 'รหัสไปรษณีย์',
    zipcode_hint: 'รหัสไปรษณีย์ / จังหวัด / (เขต/อำเภอ) / (แขวง/ตำบล)',
    phone_max_10: 'เบอร์โทรต้องไม่เกิน 10 หลัก',
    store_code: 'รหัสร้าน',
    store_name: 'ชื่อร้าน',
    contact: 'ผู้ติดต่อ',
    address: 'ที่อยู่',
    table_count: 'จำนวนโต๊ะ',
    import_stopped_at_row: 'หยุดนำเข้าตั้งแต่แถวที่',
    import_hint_store: 'ไฟล์ต้องมีคอลัมน์ รหัสร้าน, ชื่อร้าน, ผู้ติดต่อ, เบอร์โทร, ที่อยู่, ตำบล/แขวง, รหัสไปรษณีย์, ช่องทาง (ON หรือ TT) และ Location รหัสร้านที่มีอยู่แล้วจะถูกอัปเดต ไม่สร้างซ้ำ',

    // โควตา
    quota: 'จัดสรรโควตา',
    quota_management: 'จัดสรรโควตาสินค้า',
    quota_by_location: 'โควตาตาม Location',
    quota_summary: 'สรุปเทียบ stock',
    select_location: 'เลือก Location',
    only_allocated: 'เฉพาะสินค้าที่จัดสรรแล้ว',
    only_over_allocated: 'เฉพาะสินค้าที่จัดสรรเกิน',
    product: 'สินค้า',
    sku: 'SKU',
    warehouse: 'คลัง',
    quota_qty: 'โควตา',
    quota_total: 'โควตารวม',
    product_count: 'สินค้าที่จัดสรร',
    back: 'กลับ',
    reserved_qty: 'จองแล้ว',
    used_qty: 'ใช้แล้ว',
    available_qty: 'คงเหลือ',
    stock_qty: 'stock พร้อมขาย',
    allocated_qty: 'โควตาคงเหลือรวม',
    unallocated_qty: 'ยังไม่จัดสรร',
    save_changes: 'บันทึกการเปลี่ยนแปลง',
    changed: 'รายการที่แก้ไข',
    quota_must_not_negative: 'ต้องไม่ติดลบ',
    unsaved_changes: 'มีรายการที่แก้ไขแล้วยังไม่บันทึก ต้องการทิ้งการแก้ไขหรือไม่',
    over_allocated_warning: 'มีสินค้าที่โควตาคงเหลือรวมทุก Location มากกว่า stock พร้อมขาย จำนวน',
    items: 'รายการ',
    over_allocated: 'จัดสรรเกิน',
    import_hint_quota: 'ไฟล์ต้องมีคอลัมน์ ช่องทาง (ON หรือ TT), Location, SKU และ โควตา แถวที่มีอยู่แล้วจะถูกแทนด้วยค่าใหม่'
  },
  EN: {
    oms: 'OMS',
    location: 'Stock Location',
    my_product: 'My products',
    stock_group: 'Stock',
    warehouse_transfer: 'Import/Export/Transfer products',
    location_management: 'Manage Stock Location',
    add_location: 'Add Location',
    edit_location: 'Edit Location',
    import_excel: 'Import from Excel',
    download_template: 'Download template',
    channel: 'Channel',
    channel_on: 'ON (On-premise)',
    channel_tt: 'TT (Traditional Trade)',
    code: 'Code',
    name: 'Location name',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    no: 'No',
    edit: 'Edit',
    record: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    search: 'Search',
    all: 'All',
    please_specify: 'Required',
    no_data: 'No data',
    success: 'Success',
    cannot_perform_operation: 'Unable to complete the operation',
    network_error: 'Cannot connect to the server. Please try again.',
    choose_file: 'Choose an Excel file',
    import_result: 'Import result',
    import_success_count: 'Imported',
    import_error_count: 'Failed',
    rows: 'rows',
    row: 'Row',
    reason: 'Reason',
    file_empty: 'No data found in the file',
    import_hint_location: 'The file needs the columns Channel (ON or TT), Code (optional) and Location name. Existing names are updated, not duplicated.',

    // user
    user: 'Users',
    user_management: 'Manage users',
    add_user: 'Add user',
    edit_user: 'Edit user',
    create_account: 'Create a new account',
    phone: 'Phone',
    password: 'Password',
    confirm_password: 'Confirm password',
    password_mismatch: 'Passwords do not match',
    change_password: 'Change password',
    change_my_password: 'Change my password',
    current_password: 'Current password',
    new_password: 'New password',
    password_changed_relogin: 'Password changed. Please sign in again.',
    staff: 'User',
    username: 'Username',
    staff_name: 'Name',
    role: 'Role',
    role_ADMIN: 'Admin',
    role_CREATOR: 'Sale',
    role_APPROVER: 'Manager',
    channel_ALL: 'All channels',
    delete: 'Delete',
    confirm: 'Confirm',
    confirm_delete_user: 'Remove OMS access for this user. The system account is kept.',
    all_location: 'All locations',
    import_hint_user: 'The file needs the columns Username (the account must exist), Channel (ON or TT), Role (ADMIN, CREATOR or APPROVER) and Location. Separate several locations with |',

    // order
    add_order: 'Create order',
    order_list: 'Orders',
    edit_order_request: 'Edit order',
    order_info: 'Order information',
    request_no: 'Request no.',
    submitted_at: 'Submitted',
    created_by: 'Created by',
    date_from: 'From',
    date_to: 'To',
    only_mine: 'Mine only',
    items_and_pieces: 'Items / pieces',
    pieces: 'pieces',
    selected: 'Selected',
    only_selected: 'Selected only',
    order_qty: 'Order quantity',
    remark: 'Remark',
    express: 'Carrier',
    sales_channel: 'Sales channel',
    please_select_express: 'Please select a carrier',
    please_select_sales_channel: 'Please select a sales channel',
    round: 'Round',
    reject_reason: 'Rejection reason',
    submit_for_approval: 'Submit for approval',
    resubmit: 'Submit again',
    edit_and_resubmit: 'Edit and resubmit',
    cancel_order_request: 'Cancel order',
    confirm_cancel_order_request: 'Cancel this order? The reserved quota will be released.',
    approval_history: 'Approval history',
    submitted_wait_manager: 'Order submitted. Waiting for manager approval.',
    no_on_location: 'This account is not assigned to an ON location, so it cannot create orders that need approval.',
    no_product_in_location: 'This location has no product quota yet',
    store_has_no_address: 'This store has no shipping address. Please contact an admin.',
    please_select_store: 'Please select a store',
    please_select_product: 'Please enter a quantity for at least one product',
    order_qty_over_available: 'Some products exceed the available quantity',
    product_no_longer_available: 'Some selected products no longer have quota in this location. Please review the list.',
    available_now: 'Available now',
    approval: 'Approve orders',
    approval_pending: 'Pending',
    my_action: 'My approvals',
    approved_by_me: 'Approved by me',
    rejected_by_me: 'Rejected by me',
    approve_selected: 'Approve selected',
    approve_result: 'Approved',
    confirm_approve_manager: 'After approval the order is passed to an admin for final approval.',
    confirm_approve_admin: 'After approval the real order is created and sent to the warehouse immediately. It cannot be cancelled from this page.',
    reject_order_request: 'Reject order',
    reject_hint: 'The order goes back to its creator for editing and the reserved quota is released.',
    approved_order_created: 'Approved. Order no.',
    status_WAIT_MANAGER: 'Waiting for manager',
    status_WAIT_ADMIN: 'Waiting for admin',
    status_REJECTED: 'Rejected',
    status_CANCELLED: 'Cancelled',
    status_APPROVED: 'Approved',
    tab_order: 'Orders',
    action_SUBMIT: 'Submitted',
    action_RESUBMIT: 'Edited and resubmitted',
    action_APPROVE: 'Approved',
    action_REJECT: 'Rejected',
    action_CANCEL: 'Cancelled',
    level_CREATOR: 'Sale',
    level_MANAGER: 'Manager',
    level_ADMIN: 'Admin',
    action_ORDER_CANCELLED: 'Order cancelled by warehouse, stock returned',
    status_ORDER_CANCELLED: 'Order cancelled by warehouse, stock returned',
    create_order_now: 'Create order',
    order_created_direct: 'Order created and sent to the warehouse',

    // stock / store
    stock: 'Stock',
    stock_by_location: 'Stock by location',
    only_available: 'Orderable products only',
    no_location_assigned: 'This account is not assigned to any location. Please contact an admin.',
    store: 'Stores',
    add_store: 'Add store',
    edit_store: 'Edit store',
    zipcode: 'Postcode',
    zipcode_hint: 'Postcode / province / district / sub-district',
    phone_max_10: 'The phone number must not exceed 10 digits',
    store_code: 'Store code',
    store_name: 'Store name',
    contact: 'Contact',
    address: 'Address',
    table_count: 'Tables',
    import_stopped_at_row: 'import stopped from row',
    import_hint_store: 'The file needs the columns Store code, Store name, Contact, Phone, Address, Sub-district, Postcode, Channel (ON or TT) and Location. Existing store codes are updated, not duplicated.',

    // quota
    quota: 'Quota',
    quota_management: 'Allocate product quota',
    quota_by_location: 'Quota by location',
    quota_summary: 'Summary vs stock',
    select_location: 'Select a location',
    only_allocated: 'Allocated products only',
    only_over_allocated: 'Over-allocated products only',
    product: 'Product',
    sku: 'SKU',
    warehouse: 'Warehouse',
    quota_qty: 'Quota',
    quota_total: 'Total quota',
    product_count: 'Allocated products',
    back: 'Back',
    reserved_qty: 'Reserved',
    used_qty: 'Used',
    available_qty: 'Available',
    stock_qty: 'Sellable stock',
    allocated_qty: 'Remaining quota (all locations)',
    unallocated_qty: 'Unallocated',
    save_changes: 'Save changes',
    changed: 'Edited rows',
    quota_must_not_negative: 'Must not be negative',
    unsaved_changes: 'There are unsaved edits. Discard them?',
    over_allocated_warning: 'Products whose remaining quota across all locations exceeds sellable stock:',
    items: 'items',
    over_allocated: 'Over-allocated',
    import_hint_quota: 'The file needs the columns Channel (ON or TT), Location, SKU and Quota. Existing rows are replaced with the new value.'
  }
}

// ภาษาที่ไม่มีคำแปลใช้ภาษาไทย
export function getOmsLanguage () {
  return oms_language[localStorage.getItem('set_language')] || oms_language.TH
}
